import React, { Component } from 'react'

class Experience extends React.Component{
    render() {
      return (
            <div className="col-md-4 text-center animate-box">
              <div className={"services color-".concat(this.props.color)}>
                <span className="icon">
                      <i class={"icon-".concat(this.props.icon)}></i>
                </span>
                <div className="desc">
                      <h3>{this.props.title}</h3>
                    <p>{this.props.content}</p>
                </div>
                </div>
            </div>
      )
    }
  }


export default class Introduction extends Component {
  render() {
    return (
      <div>
        <section className="colorlib-about" data-section="Introduction">
        <div className="colorlib-narrow-content">
            <div className="row">
            <div className="col-md-12">
                <div className="row row-bottom-padded-sm animate-box" data-animate-effect="fadeInLeft">
                <div className="col-md-12">
                    <div className="about-desc">
                    <span className="heading-meta">Introduction</span>
                    <h2 className="colorlib-heading">About Me...</h2>
                      <p>I am Tianfeng Lu. After graduating from Zhejiang University, now I am continuing my journey in computational biology research at WashU. </p>
                      <p>The Gateway Arch in St Louis, taken in Neuroscience Research Building (NRB)</p>
                      <img
          src="images/Arch.jpg"
          alt="The Gateway Arch in St Louis, taken in Neuroscience Research Building (NRB)"
          style={{ width: '50%', height: 'auto' }}
      />
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
        </section>
        <section className="colorlib-about">
        <div className="colorlib-narrow-content">
            <div className="row">
            <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
                <span className="heading-meta">What have I learned?</span>
                <h2 className="colorlib-heading">My skills</h2>
            </div>
            </div>
            <div className="row row-pt-md">
                <Experience title="Computing Science" content="Data structure and algorithm. Programming in C, Cpp, python, R." color="2" icon="code"></Experience>
                <Experience title="Bioinformatics" content="Bioinformatics analysis for next-generation sequencing." color="4" icon="chart-pie"></Experience>
                <Experience title="Mathematics" content="Basic courses in analysis and statistics. Expertise in algebra and geometry." color="6" icon="pi-outline"></Experience>

            </div>
        </div>
        </section>
      </div>
    )
  }
}
